
  export default {
    meta: {
      breadcrumbs: [['i18n/home', '/', 'mobile'], 'i18n/guaranteed-irish']
    },
    middleware: ['breadcrumbs', 'jumbotron', 'meta-tags']
  };
